<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>En 1667 se instituye el 12 de diciembre como Jubileo plenísimo a la Virgen de Guadalupe</h2>
    <img @click="imageClicked(0)" src="galerias/guadalupe/g5/G5.jpg" class="mainphoto"/>
    <p class="photo-description">Retrato de Clemente IX. Autor: Gian Lorenzo Bernini. Siglo XVII. Colección privada</p>
    <p>El Papa Clemente IX estableció en 1667 un Jubileo plenísimo para el día 12 de diciembre a la Virgen de Guadalupe prosiguiendo la causa en la Congregación de Ritos para otorgar fiesta y misa propia como había sido petición del Cabildo catedralicio de la Arquidiócesis de México.</p>
    <p>El Papa Clemente IX falleció ese mismo año al igual que otros dos ilustres guadalupanos esforzados en la aprobación del jubileo, el Dr. Siles (electo  Arzobispo de Manila) y el Canónigo Peralta de Puebla.</p>
    <!-- <h5>VER MÁS</h5> -->
    <!-- <p>
      <ul>
        
      </ul>
    </p> -->

    <h4>La Virgen de Guadalupe se declara patrona protectora de la Ciudad de Los Ángeles, hoy Puebla (1675)</h4>
    <img @click="imageClicked(1)" class="mainphoto" src="galerias/guadalupe/g5/G5_A.jpg"/>
    <p>Aunque es muy citada la jura de patronazgo de Puebla de los Ángeles en 1737 a la Virgen de Guadalupe, es poco conocida la jura anterior fechada en 1675, en la que la Ciudad de Puebla declaró a la Virgen como patrona protectora.</p>
    <p>En la imagen se muestra la pintura de la Virgen de Guadalupe de Manuel de Arellano (1675), propiedad del Museo de América (Madrid, España).</p>
    <p>Si deseas conocer más:
      <ul>
        <li><a target="_blank" href="http://52.183.37.55/artworks/3840">ARCA arte colonial</a></li>
      </ul>
    </p>
    
    <h4>Francisco de Florencia publica la Estrella del Norte de México (1688)</h4>
    <img @click="imageClicked(2)" class="mainphoto" src="galerias/guadalupe/g5/G5_B.jpg"/>
    <p>Francisco de Florencia, jesuita, historiador y biógrafo nacido en Nueva España, fue nombrado rector del Colegio del Espíritu Santo en la ciudad de Puebla de los Ángeles en 1680. Publicó “La Estrella del Norte de México, aparecida al rayar el día de la luz evangélica en este Nuevo Mundo, en la cumbre del cerro de Tepeyacac, orilla del mar Tezcunano, a un natural recién convertido... “ En la historia de la milagrosa imagen de Nuestra Señora de Guadalupe de México, que se apareció en la manta de Juan Diego”.</p>
    <p>En la imagen se muestra una de las ilustraciones de la obra en una edición de 1785, que representa el momento en que el Obispo Juan Fray de Zumárraga admira la tilma con la imagen de la Virgen de Guadalupe.</p>
    <p>Si deseas conocer más:
      <ul>
        <li><a target="_blank" href="http://www.cervantesvirtual.com/obra/la-estrella-de-el-norte-de-mexico-aparecida-al-rayar-el-dia-de-la-luz-evangelica-en-este-nuevomund-0/">www.cervantesvirtual.com</a></li>
        <li><a target="_blank" href="http://dbe.rah.es/biografias/20315/francisco-de-florencia">dbe.rah.es</a></li>
        <li><a target="_blank" href="http://cdigital.dgb.uanl.mx/la/1080012123/1080012123.PDF">cdigital.dgb.uanl.mx</a></li>
        <li><a target="_blank" href="https://gallica.bnf.fr/ark:/12148/btv1b23000403/f4.item#">gallica.bnf.fr</a></li>
      </ul>
    </p>
  </div>
</template>

<script>
export default {
  name: "Sala2m4",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    }
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
